import {
    WithId,
} from 'app/types/common.types'
import ContainerTypeUpdate from '../ContainerTypeUpdate'

const ContainerTypeOverview = ({
    id,
}: Readonly<WithId<string>>) => {
    return (
        <ContainerTypeUpdate
            id={id}
            disabled
        />
    )
}

export default ContainerTypeOverview
